import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate, HUECOS_TIPO } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const lbl = "text-[11px] font-semibold uppercase text-slate-500";

export const HuecoDiaDialog = ({ h, profs, onClose, onDone }) => {
  const [f, setF] = useState(null);
  useEffect(() => {
    setF(h ? { hueco_id: h.id, fecha: h.fecha, profesional_id: h.profesional_id, inicio: h.inicio, fin: h.fin, tipo: h.tipo, nota: h.nota || "" } : null);
  }, [h]);
  if (!f || !h) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const run = async (fn, msg) => {
    try {
      const r = await fn();
      toast.success(msg);
      if (r?.data?.aviso) toast.warning(r.data.aviso, { duration: 8000 });
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const guardar = () => run(() => api.post("/huecos-dia/mover", { ...f, fecha_origen: h.fecha }), f.fecha === h.fecha ? "Hueco cambiado solo para este día" : `Hueco pasado al ${fmtDate(f.fecha)}`);
  const quitar = () => run(() => (h.extra ? api.delete("/huecos-dia", { params: { hueco_id: f.hueco_id, fecha: f.fecha } }) : api.put("/huecos-dia", { ...f, fecha: h.fecha, borrado: true })), "Hueco quitado solo este día");
  const volver = () => run(() => api.delete("/huecos-dia", { params: { hueco_id: f.hueco_id, fecha: f.fecha } }), "Hueco devuelto como en la semana tipo");
  return (
    <Dialog open={!!h} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="hueco-dia-dialog">
        <DialogHeader><DialogTitle className="font-[Outfit]">Cambiar hueco solo el {fmtDate(f.fecha)}</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500 -mt-2">La semana tipo no se toca: las demás semanas el hueco sigue igual.</p>
        <div className="grid grid-cols-3 gap-2">
          {Object.entries(HUECOS_TIPO).map(([k, t]) => (
            <button key={k} type="button" onClick={() => setF({ ...f, tipo: k })} data-testid={`hueco-dia-tipo-${k}`}
              className="rounded-md border px-2 py-1.5 text-xs font-medium transition-colors" style={f.tipo === k ? { background: t.color, borderColor: t.color, color: "#fff" } : { borderColor: `${t.color}66`, color: t.color }}>{t.label}</button>
          ))}
        </div>
        <div className="grid grid-cols-3 gap-2">
          <label className={`${lbl} col-span-2`}>Profesional
            <select className="field-select mt-1" value={f.profesional_id} onChange={set("profesional_id")} data-testid="hueco-dia-prof">{profs.map((p) => <option key={p.id} value={p.id}>{p.nombre}</option>)}</select>
          </label>
          <label className={lbl}>Día<Input type="date" value={f.fecha} onChange={set("fecha")} data-testid="hueco-dia-fecha" className="mt-1" /></label>
          <label className={lbl}>Inicio<Input type="time" step="900" value={f.inicio} onChange={set("inicio")} data-testid="hueco-dia-inicio" className="mt-1" /></label>
          <label className={lbl}>Fin<Input type="time" step="900" value={f.fin} onChange={set("fin")} data-testid="hueco-dia-fin" className="mt-1" /></label>
          <label className={lbl}>Nota<Input value={f.nota} onChange={set("nota")} data-testid="hueco-dia-nota" className="mt-1" placeholder="opcional" /></label>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" className="text-rose-700" onClick={quitar} data-testid="hueco-dia-quitar">Quitar este día</Button>
          {h.cambiado && !h.extra && <Button variant="outline" onClick={volver} data-testid="hueco-dia-volver">Volver al de la semana tipo</Button>}
          <div className="flex-1" />
          <Button onClick={guardar} data-testid="hueco-dia-save" className="bg-[#1E3A8A] hover:bg-[#1E40AF]">Guardar</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
